import { GetterTree } from 'vuex';
import { IAuthState, IRootStore, IUserState } from '@/store/types';

export const getters: GetterTree<IUserState, IRootStore> = {
  userProfile: state => state.profile,
};
